export const GET_ALL_DISCUSSIONS = 'GET_ALL_DISCUSSIONS'
export const ADD_DISCUSSION = 'ADD_DISCUSSION'
export const REMOVE_DISCUSSION = 'REMOVE_DISCUSSION'
export const ADD_DCOMMENT = 'ADD_DCOMMENT'
export const REMOVE_DCOMMENT = 'REMOVE_DCOMMENT'
